export default __webpack_public_path__ + "static/media/negx.9767b408.jpg";